import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'app/shared/modules/shared.module';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import localePt from '@angular/common/locales/pt';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedService } from 'app/core/services/shared.service';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { ErrorInterceptor } from 'app/core/interceptors/error.interceptor';
import { JwtInterceptor } from 'app/core/interceptors/jwt.interceptor';
import { LayoutModule } from './layout/layout.module';
import { SuccessInterceptor } from 'app/core/interceptors/success.interceptor';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    LayoutModule,
    FontAwesomeModule
  ],
  providers: [
    JwtHelperService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS, },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptor, multi: true },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    SharedService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
